uniform vec3  u_sunPosition;
uniform vec3  u_color;
uniform float u_edgeSharpness;
uniform float u_dayBias;
uniform bool  u_useSun;       

varying vec3 vNormal;
varying vec3 vNormalView;
varying vec3 vPosition;
varying vec3 vWorldPos;

void main() {
  float mixAmountReal;
  if (u_useSun) {
    vec3 sunDirUnit = normalize(u_sunPosition - vWorldPos);
    float cosA      = dot(vNormal, sunDirUnit);
    mixAmountReal  = 1.0 / (1.0 + exp(-u_edgeSharpness * (cosA + u_dayBias)));
  } else {
    mixAmountReal = 1.0;  
  }

  float rawIntensity = 3.0 * max(dot(vPosition, vNormalView), 0.0);
  float intensity    = pow(rawIntensity, 3.0);

  gl_FragColor = vec4(u_color, intensity) * mixAmountReal;
}
